import {bindable, BindingEngine, computedFrom, containerless, customElement, inject} from 'aurelia-framework';
import {FlashService} from '../flash/flash-service';
import {StandardActions} from './standard-actions';
import {ActionConfigPreparation} from "./action-config-preparation";
import {EventAggregator} from 'aurelia-event-aggregator';
import {Router} from 'aurelia-router';
import * as _ from 'lodash';
import printJS from 'print-js';
import {I18N} from 'aurelia-i18n';


import "./action.less";
import {UserClient} from "../api/user-client";

@customElement('sio-internal-action')
@containerless()
@inject(FlashService, StandardActions, EventAggregator, Router, I18N)
export class ActionClass {
    @bindable config;
    @bindable action;
    @bindable context = {};

    @bindable onBeforeClick = undefined; // Hook: Called after successful action execution
    @bindable onAfterSuccess = undefined; // Hook: Called after successful action execution
    @bindable redirectAfterDelete = false; // Hook: Called after successful action execution

    element;
    loading = false;

    disabledByActiveForm = false;

    constructor(flash, standard, ea, router, i18n) {
        this.flash = flash;
        this.standard = standard;
        this.ea = ea;
        this.router = router;
        this.i18n = i18n;
    }

    @computedFrom('_config.buttonClass', 'loading', '_config.disabled')
    get buttonClass() {
        let buttonClass;

        if (this._config.buttonClass !== undefined) {
            buttonClass = this._config.buttonClass;
        } else {
            buttonClass = 'tw-btn-default';
        }

        if (!this._config.icon) {
            buttonClass += ' no-icon';
        } else {

        }

        if (this._config.disabled || this.loading) {
            buttonClass += ' disabled';
        }

        return buttonClass + ' btn-sm sio-action';
    }

    attached() {
        this.disableActionsSubscription = this.ea.subscribe('sio_disable_actions', () => {

            if ('workflow' === this._config.type) {
                this.disabledByActiveForm = true;
                this._config.disabled = true;
            }
        });

        this.enableActionsSubscription = this.ea.subscribe('sio_enable_actions', () => {

            this.disabledByActiveForm = false;
            this._config.disabled = false;
        });

        this.formPreSubmitSubscription = this.ea.subscribe('sio_form_post_submit', () => {

            this.disabledByActiveForm = false;
            this._config.disabled = false;
        });

        this.formCancelSubscription = this.ea.subscribe('sio_form_cancel', () => {

            this.disabledByActiveForm = false;
            this._config.disabled = false;
        });

        this.formValueChangedSubscription = this.ea.subscribe('sio_form_value_changed', () => {

            if ('workflow' === this._config.type) {
                this.disabledByActiveForm = true;
                this._config.disabled = true;
            }
        });

        let hasWarning = this._config.warning != null && this._config.warning !== '';
        let hasHelp = this._config.help != null && this._config.help !== '';

        if (hasWarning || hasHelp || (this._config.showLabel === false) || this._config.noPermission) {
            //Bugfix function missing for calling aciton inside editor (e.g. form-choice)
            $.fn.emulateTransitionEnd = function (duration) {
                var called = false, $el = this
                $(this).one($.support.transition.end, function () {
                    called = true
                })
                var callback = function () {
                    if (!called) $($el).trigger($.support.transition.end)
                }
                setTimeout(callback, duration)
                return this
            };

            $(this.element).popover({
                //Bugfix for popover not dynamically updated
                content: () => {
                    let content = '<b>' + this.i18n.tr(this._config.title ?? this._config.label) + '</b><br>';

                    if (this._config.noPermission) {
                        content = '<span class="tw-text-secondary tw-font-medium"><i class="fa fa-ban"></i> ' + this.i18n.tr('accessDenied') + '</span><br>';
                    }

                    let help = this.i18n.tr(this._config.help);
                    let warning = hasWarning ? this.i18n.tr('sio.field.warnings') + ': ' + this.i18n.tr(this._config.warning) : '';

                    return content + '<small>' + help + ((hasWarning && hasHelp) ? '<br><br>' : '') + warning + '</small>';
                },
                container: 'body',
                placement: 'auto bottom',
                trigger: 'hover',
                delay: {show: 150, hide: 0},
                html: true,
                sanitize: false,
            });
        }
    }

    detached() {
        if (this.disableActionsSubscription) {
            this.disableActionsSubscription.dispose();
        }

        if (this.enableActionsSubscription) {
            this.enableActionsSubscription.dispose();
        }

        if (this.formPreSubmitSubscription) {
            this.formPreSubmitSubscription.dispose();
        }

        if (this.formCancelSubscription) {
            this.formCancelSubscription.dispose();
        }

        if (this.formValueChangedSubscription) {
            this.formValueChangedSubscription.dispose();
        }

        if (this.element) {
            $(this.element).popover('destroy')
        }
    }

    // noinspection JSUnusedGlobalSymbols
    configChanged() {
        this._config = ActionConfigPreparation.prepare(this.config);

        if (this.disabledByActiveForm) {
            this._config.disabled = true;
        }

        this.tryRecomputeAction();
    }

    // noinspection JSUnusedGlobalSymbols
    contextChanged() {
        this.tryRecomputeAction();
    }

    // noinspection JSUnusedGlobalSymbols
    actionChanged() {
        this.tryRecomputeAction();
    }

    tryRecomputeAction() {
        // Reset context, because if it was set previously as standardAction.context,
        // changes in action could lead to inconsistency
        this._context = this.context ? _.cloneDeep(this.context) : {};

        if (!this.action && this._config && this._config.type) {
            let standardAction = this.standard.getAction(this._config, this._context);

            if (standardAction) {
                this._action = standardAction.action;
                this._context = standardAction.context;
            }
        } else if (this._config.actionCallback) {
            this._action = this._config.actionCallback;
        } else {
            this._action = this.action ? this.action : undefined;
        }
    }

    click() {
        if (this._config.disabled || this.loading) {
            return false;
        }

        let dynamicData = null;

        if (this.onBeforeClick) {
            dynamicData = this.onBeforeClick();
        }

        let result = this._action(dynamicData);

        if (!result || true === result) {
            return false;
        }

        this.loading = true;

        result.then(data => {

            if (this.redirectAfterDelete && this.config.redirectAfter) {

                this.router.navigate(this.config.redirectAfter);

            } else if (this._config.hasOwnProperty('openUrlProperty')) {

                const url = _.get(data, this._config.openUrlProperty);

                if (url) {
                    const win = window.open(url, '_blank');
                    win.focus();
                }

            } else if (this._config.hasOwnProperty('downloadProperty')) {

                const url = _.get(data, this._config.downloadProperty);

                if (url) {
                    if (Array.isArray(url)) {
                        url.forEach((urlPart) => {
                            window.open(urlPart);
                        });
                    } else {
                        window.location.href = url;
                    }
                }

            } else if (this._config.hasOwnProperty('printProperty')) {

                const url = _.get(data, this._config.printProperty);

                //Printing only supports api domain atm, as it needs CORS headers appropiately set
                if (url) {
                    printJS({printable: url, type: 'pdf'});
                }

            } else if (this._config.hasOwnProperty('redirect')) {

                const url = _.get(data, this._config.redirect);

                if (url) {
                    this.router.navigate(url);
                }

            } else if (this._config.reload) {

                location.reload();

            }

            if (this.onAfterSuccess) {
                this.onAfterSuccess(data);
            }

        }, error => {
            if (error?.status || error?.data) {
                console.error('Action error', error);

                if (403 === error.status) {
                    this.flash.error('sio.access_denied');
                } else {
                    const response = error.data;

                    if (response.message) {
                        this.flash.error(response.message);
                    } else {
                        this.flash.error('action.could_not_be_executed');
                    }
                }
            }
        }).finally(() => {
            this.loading = false;
        });
    }
}
